<template>
  <div class="content-wrapper">
    <div class="col-12 mb-primary">
      <div class="card card-with-shadow border-0 h-100">
        <div class="card-header p-primary bg-transparent">
          <h5 class="card-title d-inline-block mb-0">{{ $t("view_job") }}</h5>
          <!-- <div class="float-right">
                        <a href="/buyer/job" class="btn btn-primary btn-sm">Back</a>
                    </div> -->
        </div>
        <app-overlay-loader v-if="preloader" />
        <div class="card-body">
          <form
            class="mb-0"
            :class="{ 'loading-opacity': preloader }"
            ref="form"
            :data-url="selectedUrl ? `crud/${inputs.id}` : `crud`"
          >
            <div class="form-group row align-items-center">
              <label for="inputs_name" class="col-sm-3 mb-0">
                {{ $t("title") }}
              </label>
              <app-input
                id="inputs_name"
                class="col-sm-3"
                type="text"
                v-model="job.title"
                :read-only="true"
              />
              <label for="inputs_name" class="col-sm-3 mb-0">
                {{ $t("category") }}
              </label>
              <app-input
                id="inputs_category"
                class="col-sm-3"
                type="text"
                v-model="job.category"
                :read-only="true"
              />
            </div>
            <div class="form-group row align-items-center">
              <label for="inputs_email" class="col-sm-3 mb-0">
                {{ $t("description") }}
              </label>
              <app-input
                id="inputs_email"
                class="col-sm-9"
                type="textarea"
                v-model="job.description"
                :read-only="true"
              />
            </div>
            <div class="form-group row align-items-center">
              <label for="inputs_email" class="col-sm-3 mb-0">
                {{ $t("assignment_structure") }}
              </label>
              <app-input
                id="inputs_email"
                class="col-sm-9"
                type="textarea"
                v-model="job.assignment_structure"
                :read-only="true"
              />
            </div>
            <div class="form-group row align-items-center">
              <label for="inputs_status" class="col-sm-3 mb-0">
                {{ $t("start_date") }}
              </label>
              <app-input
                id="inputs_status"
                class="col-sm-3"
                type="text"
                :read-only="true"
                v-model="job.start_date"
              />
              <label for="inputs_status" class="col-sm-3 mb-0">
                {{ $t("end_date") }}
              </label>
              <app-input
                id="inputs_status"
                class="col-sm-3"
                type="text"
                :read-only="true"
                v-model="job.end_date"
              />
            </div>
            <div class="form-group row align-items-center">
              <label for="inputs_status" class="col-sm-2 mb-0">
                {{ $t("job_type") }}
              </label>
              <app-input
                id="inputs_status"
                class="col-sm-2"
                type="select"
                :disabled="true"
                v-model="job.job_type"
                :list="jobTypeList"
              />
              <label for="inputs_status" class="col-sm-2 mb-0">
                {{ $t("job_status") }}
              </label>
              <app-input
                id="inputs_status"
                class="col-sm-2"
                type="text"
                :disabled="true"
                v-model="job.status"
              />
              <label for="inputs_status" class="col-sm-2 mb-0">
                {{ $t("is_private") }}
              </label>
              <app-input
                id="inputs_status"
                class="col-sm-2"
                type="select"
                :disabled="true"
                v-model="job.is_private"
                :list="is_private"
              />
              <!-- <label for="inputs_status" class="col-sm-3 mb-0">
                {{ $t("published") }}
              </label>
              <app-input
                id="inputs_status"
                class="col-sm-3"
                type="select"
                :disabled="true"
                v-model="job.published"
                :list="publishedList"
              /> -->
            </div>
          </form>
        </div>

        <div class="text-right mr-5 mb-5" v-if="sitecreate == true">
          <button
            type="button"
            class="btn btn-primary btn-with-shadow"
            @click="createsite"
          >
            {{ $t("add_site") }}
          </button>
        </div>
        <div v-for="(s, sIndex) in site" :key="sIndex">
          <div style="box-shadow: var(--sidebar-box-shadow)">
            <div class="card-body">
              <div class="form-group row" style="align-items: center">
                <div class="col-sm-8">
                  <h5>{{ $t("create_site") }}</h5>
                </div>
                <div class="col-sm-4">
                  <div style="text-align: end">
                    <button
                      class="btn btn-primary"
                      type="button"
                      data-toggle="tooltip"
                      data-placement="top"
                      title="Add Task"
                      v-on:click="addNewTask(sIndex)"
                      name="plus-square"
                    >
                      +
                    </button>
                    <button
                      type="button"
                      data-toggle="tooltip"
                      data-placement="top"
                      title="Remove"
                      class="btn btn-danger"
                      name="minus-square"
                      v-on:click="popSite(sIndex)"
                    >
                      -
                    </button>
                    <!-- <button
                      type="button"
                      data-toggle="tooltip"
                      data-placement="top"
                      title="Add Site"
                      class="btn btn-dark"
                      v-on:click="addNewSite"
                      name="plus-square"
                    >
                      +
                    </button> -->
                  </div>
                </div>
              </div>
              <form
                class="mb-0"
                :class="{ 'loading-opacity': preloader }"
                ref="form"
                :data-url="selectedUrl ? `crud/${inputs.id}` : `crud`"
              >
                <div class="form-group row align-items-center">
                  <label for="inputs_name" class="col-sm-3 mb-0">
                    {{ $t("title") }}
                  </label>
                  <app-input
                    id="inputs_name"
                    class="col-sm-9"
                    type="text"
                    v-model="s.title"
                    :required="true"
                  />
                </div>
                <div class="form-group row align-items-center">
                  <label for="inputs_email" class="col-sm-3 mb-0">
                    {{ $t("description") }}
                  </label>
                  <app-input
                    id="inputs_email"
                    class="col-sm-9"
                    type="textarea"
                    v-model="s.description"
                    :required="true"
                  />
                </div>
                <div class="form-group row align-items-center">
                  <label for="inputs_email" class="col-sm-3 mb-0">
                    {{ $t("start_time") }}
                  </label>
                  <app-input
                    id="inputs_email"
                    class="col-sm-3"
                    type="time"
                    v-model="s.start_time"
                    :required="true"
                  />
                  <label for="inputs_email" class="col-sm-3 mb-0">
                    {{ $t("end_time") }}
                  </label>
                  <app-input
                    id="inputs_email"
                    class="col-sm-3"
                    type="time"
                    v-model="s.end_time"
                    :required="true"
                  />
                </div>
                <div class="form-group row align-items-center">
                  <label for="inputs_email" class="col-sm-2 mb-0">
                    {{ $t("assignment_structure") }}
                  </label>
                  <app-input
                    id="inputs_email"
                    class="col-sm-10"
                    type="textarea"
                    v-model="s.assignment_structure"
                    :required="true"
                  />
                </div>
              </form>
            </div>
          </div>
          <div
            style="box-shadow: var(--sidebar-box-shadow); margin-top: 10px"
            v-for="(t, index) in s.task"
            :key="index"
          >
            <div class="card-body">
              <div class="form-group row">
                <div class="col-sm-8 col-12">
                  <h5>{{ $t("store_tasks") }}</h5>
                </div>
                <div class="col-sm-4 col-12">
                  <div style="text-align: end">
                    <!-- <button
                      class="btn btn-primary"
                      data-toggle="tooltip"
                      data-placement="top"
                      title=""
                      type="button"
                      v-on:click="addNewTask(sIndex)"
                      name="plus-square"
                    >
                      +
                    </button> -->
                    <button
                      class="btn btn-danger"
                      data-toggle="tooltip"
                      data-placement="top"
                      title="Remove"
                      type="button"
                    >
                      -
                    </button>
                  </div>
                </div>
              </div>
              <form
                class="mb-0"
                :class="{ 'loading-opacity': preloader }"
                ref="form"
                :data-url="selectedUrl ? `crud/${inputs.id}` : `crud`"
              >
                <div class="form-group row align-items-center">
                  <label for="inputs_name" class="col-sm-3 mb-0">
                    {{ $t("title") }}
                  </label>
                  <app-input
                    id="inputs_name"
                    class="col-sm-9"
                    type="text"
                    v-model="t.title"
                    :required="true"
                  />
                </div>
                <div class="form-group row align-items-center">
                  <label for="inputs_email" class="col-sm-3 mb-0">
                    {{ $t("description") }}
                  </label>
                  <app-input
                    id="inputs_email"
                    class="col-sm-9"
                    type="textarea"
                    v-model="t.description"
                    :required="true"
                  />
                </div>
              </form>
            </div>
          </div>
        </div>
        <div class="action-buttons" v-if="seen == true" style="text-align: end">
          <div class="card-body">
            <button
              type="submit"
              class="btn btn-primary mr-2"
              @click.prevent="storeSite"
            >
              {{ $t("submit") }}
            </button>
            <button
              type="submit"
              class="btn btn-secondary"
              @click.prevent="clear"
            >
              {{ $t("clear") }}
            </button>
          </div>
        </div>
        <div class="card-body">
          <form
            ref="form"
            data-url="/crud"
            class="mb-0"
            :class="{ 'loading-opacity': preloader }"
          >
            <div class="row">
              <div class="col-md-12">
                <div class="form-group">
                  <label>{{ $t("assigned_supplier") }}</label>
                  <table class="table">
                    <tr v-if="notNull == true">
                      <td>{{ assignSupplier.bid.company.company_name }}</td>
                      <td>{{ assignSupplier.bid.company.company_email }}</td>
                      <td>{{ assignSupplier.bid.company.company_phone }}</td>
                      <td>{{ assignSupplier.bid.bid_amount }}</td>
                      <td>
                        <button class="btn btn-primary btn-sm">view</button>
                      </td>
                    </tr>
                  </table>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-lg-12 col-md-12 col-sm-12">
                <label>{{ $t("bid_list") }}</label>
                <table class="table">
                  <tr>
                    <th>S.No</th>
                    <th>Name</th>
                    <th>Email</th>
                    <th>Phone</th>
                    <th>Bid Amount</th>
                    <th>Action</th>
                  </tr>
                  <tr v-for="(bid, index) in bids" :key="index">
                    <td>{{ index + 1 }}</td>
                    <td>{{ bid.company_name }}</td>
                    <td>{{ bid.company_email }}</td>
                    <td>{{ bid.company_phone }}</td>
                    <td>{{ bid.pivot.bid_amount }}</td>
                    <td>
                      <!-- <a href="site" class="btn btn-primary btn-sm">view</a> -->
                      <button
                        type="button"
                        class="btn btn-primary btn-sm"
                        @click="assignedSupplier(bid.pivot.id)"
                      >
                        Assign
                      </button>
                    </td>
                  </tr>
                </table>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>

    <!-- <company-upload
      v-if="isAddEditModalActive"
      :selected-url="selectedUrl"
      @close-modal="closeAddEditModal"
    /> -->
  </div>
</template>

<script>
import { FormMixin } from "../../../../../../core/mixins/form/FormMixin.js";
import {
  COMPANY_JOB_SITE_STORE,
  COMPANY_JOB_STORE,
  COMPANY_JOB_GET,
  JOB_BID_LISTING,
  JOB_BID_ACCEPT,
  JOB_CATEGORY_NAME,
  JOB_CHECK_ACCEPTED_SUPPLIER,
} from "../../../../../Config/ApiUrl.js";
import { axiosGet, axiosPost } from "../../../../../Helpers/AxiosHelper.js";

export default {
  name: "FormGrid",
  mixins: [FormMixin],
  data() {
    return {
      preloader: false,
      job: {},
      site: [],
      task: [],
      bids: {},
      acceptedBid: {},
      assignSupplier: [],
      seen: false,
      sitecreate: false,
      notNull: false,
      jobTypeList: [
        { id: "", value: "Choose One" },
        { id: "On-site", value: "On-site" },
        { id: "Hybrid", value: "Hybrid" },
        { id: "Remote", value: "Remote" },
      ],
      status: [
        { id: "", value: "Choose One" },
        { id: "draft", value: "Draft" },
        { id: "active", value: "Active" },
      ],
      is_private: [
        { id: "", value: "Choose One" },
        { id: "0", value: "Public" },
        { id: "1", value: "Private" },
      ],
    };
  },
  methods: {
    beforeSubmit() {
      this.preloader = true;
    },
    submit() {
      this.save(this.inputs);
    },

    afterSuccess(res) {
      this.$toastr.s(res.data.message);
    },
    afterFinalResponse() {
      this.preloader = false;
      this.inputs = {
        gender: "male",
      };
    },
    afterError(res) {
      this.$toastr.e(res.data.message);
    },
    clear() {
      this.inputs = {};
      this.fieldStatus = {
        isSubmit: false,
      };
    },
    addNewSite() {
      this.addSite();
    },
    popSite(index) {
      this.site.splice(index, 1);
    },
    addNewTask(id) {
      this.addTask(id);
    },
    storeSite() {
      axiosPost(COMPANY_JOB_SITE_STORE, this.site)
        .then((res) => {
          this.$toastr.s(res.data.message);
          this.site = [];
          this.seen = false;
          //   
        })
        .catch((errors) => {
          
        });
    },
    addSite() {
      this.site.push({
        job_id: this.job.id,
        title: "",
        description: "",
        assignment_structure: "",
        start_time: "",
        end_time: "",
        task: [],
      });
    },
    addTask(id) {
      this.site[id].task.push({
        title: "",
        description: "",
      });
    },
    getCustomerJob() {
      let myLocation = location.href;
      let split = myLocation.split("/");
      
      let id = split[6].split("?")[0];
      //   
      axiosGet(COMPANY_JOB_GET + "/" + id)
        .then((response) => {
          //   
          this.job = response.data;
          //   this.titleinvoice = response.data.company_name;
        })
        .catch((error) => {
          
        });
    },

    getBids() {
      let myLocation = location.href;
      let split = myLocation.split("/");
      
      let id = split[6].split("?")[0];
      axiosGet(JOB_BID_LISTING + "/" + id)
        .then((res) => {
          this.bids = res.data;
        })
        .catch((error) => {
          
        });
    },
    assignedSupplier(id) {
      axiosGet(JOB_BID_ACCEPT + "/" + id)
        .then((res) => {
          this.assignSupplier = res.data;
          this.notNull = true;
          this.sitecreate = true;
        })
        .catch((error) => {
          
        });
    },

    checkAssignedSupplier() {
      let myLocation = location.href;
      let split = myLocation.split("/");
      
      let id = split[6].split("?")[0];
      axiosGet(JOB_CHECK_ACCEPTED_SUPPLIER + "/" + id)
        .then((res) => {
          this.assignSupplier = res.data;
          this.notNull = true;
          this.sitecreate = true;
        })
        .catch((error) => {
          
        });
    },
    // assignedSupplier()
    // {
    //     // alert(id);
    //     this.assignSupplier = {
    //         'id':'1',
    //         'name':'Test'
    //     }
    //     this.sitecreate = true;
    //     // this.seen = true;
    //     // this.addSite();
    //     
    // },
    getCategoryName() {
      let myLocation = location.href;
      let split = myLocation.split("/");
      
      let id = split[6].split("?")[0];
      axiosGet(JOB_CATEGORY_NAME + "/" + id)
        .then((res) => {
          
          this.job.category = res.data;

          
        })
        .catch((error) => {
          
        });
    },
    createsite() {
      this.seen = true;
      this.addSite();
    },
  },
  mounted() {
    this.getBids();
    this.getCustomerJob();
    this.checkAssignedSupplier();
    this.getCategoryName();
  },
};
</script>
